<div class="support-widget d-flex flex-column align-items-end">
  @if (isSupportWidgetOpen) {
    <div class="support-widget__content udex-mb-24 support-widget-content contact-module"
         [attr.data-cy]="'support-widget-content'">
      @if (shouldShowChat()) {
        <div
          class="btn btn-link support-widget__tile d-flex align-items-left justify-content-start chat chatNow udex-p-0"
          (click)="openChat()" [attr.data-cy]="'startChat'" [tabindex]="0">
          <div class="support-widget__image-container d-flex udex-pe-20 udex-pt-20">
            <img alt="{{'checkout.startChat'}} image"
                 src="assets/images/checkout/support-widget/discussion-2_blue.svg"/>
          </div>
          <div class="support-widget__text-container d-flex flex-column">
            <a [tabindex]="0"
               class="ds-heading--xs ds-color--blue ds-link focusable focusable__element">{{
                'checkout.startChat' |
                  cxTranslate
              }}</a>
            <p class="ds-fine-print ds-color--black">{{'checkout.startChatDescription' | cxTranslate}}</p>
          </div>
        </div>
      }
      <div (click)="openSupportRequestModal()" (keydown.enter)="openSupportRequestModal()"
           class="btn btn-link support-widget__tile support-tile d-flex align-items-left justify-content-start udex p-0"
           [attr.data-cy]="'contactUs'" [tabindex]="0">
        <div class="support-widget__image-container d-flex udex-pe-20 udex-pt-20">
          <img alt="{{'checkout.contactUs'}} image" src="assets/images/checkout/support-widget/email_blue.svg"/>
        </div>
        <div class="support-widget__text-container d-flex flex-column">

          <a [tabindex]="0"
             class="ds-heading--xs  ds-color--blue ds-link focusable focusable__element">{{
              'checkout.contactUs'
                | cxTranslate
            }}</a>
          <span class="ds-fine-print ds-color--black">{{
              'checkout.contactUsDescription' |
                cxTranslate
            }}</span>
        </div>
      </div>
    </div>
  }

  <udex-button size="Large" class="support-widget__btn support-widget-button" (click)="toggleSupportWidget()"
               icon="sap-icon://discussion-2" [active]="isSupportWidgetOpen" [attr.data-cy]="'support-widget-button'">
    <span class="button-text">{{'productDetails.contactUs' | cxTranslate}}</span>
  </udex-button>
</div>
